
import { Component, Vue, Watch } from "vue-property-decorator";
import FormItem from "./FormItem.vue";
import FormTare from "./FormTare.vue";
import FormList from "./FormList.vue";

@Component({
  name: "scanforweighbridge",
  components: {
    FormItem,
    FormTare,
    FormList
  }
})
export default class extends Vue {
  public activeName = "item";
  mounted() {
    obj_ScanForWeighbridge.sendPageIndexToNet(this.activeName);
  }
  @Watch("activeName")
  OnChanged(val, oldval) {
    console.log(oldval + "=>" + val);
    obj_ScanForWeighbridge.sendPageIndexToNet(val);
  }

  public handleClick(tab) {
    console.log(tab.paneName);
  }
}
